import React from 'react';
import { Navigate } from 'react-router-dom';
import { useResourcePermissions } from '../../hooks/useResourcePermissions';

interface RequireMenuVisibilityProps {
  resourceRoute: string;
  children: React.ReactNode;
  redirectTo?: string;
}

const RequireMenuVisibility: React.FC<RequireMenuVisibilityProps> = ({
  resourceRoute,
  children,
  redirectTo = '/dashboard',
}) => {
  const { canView, isLoadingPermissions } = useResourcePermissions(resourceRoute);

  if (isLoadingPermissions) {
    return null;
  }

  if (!canView) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RequireMenuVisibility;
